import { type DocumentNode, gql } from '@apollo/client';

const deletePermissionGroup: DocumentNode = gql`
  mutation delete_permissions_group($permissionsGroupId: ID!) {
    deletePermissionsGroup(permissionsGroupId: $permissionsGroupId) {
      success
    }
  }
`;

export default deletePermissionGroup;
